import React, { useContext } from 'react';
import { Paper,ListItem, List, Grid, Typography, Card, CardContent, CardMedia, Box} from '@mui/material';
import { useQuery } from '@apollo/client';
import * as queries from "../../../operations/queries";
import { CountryContext } from '../MainComponent';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Loader from "../Layout/loader";

// const articles = [
//   {
//     title: 'Things to Consider While Choosing The Right Coffee Filter', 
//     description: 'Most people love to drink coffee, and it is a known truth that coffee can provide a boost of energy and warm your body up on those chilly winter days. But many of us are not familiar with the use and variety of coffee machines. Without coffee machines, we probably would not witness so many people drinking this worldwide popular drink and being able to affordably prepare them at home Most people love to drink coffee, and it is a known truth that coffee can provide a boost of energy and warm your body up on those chilly winter days. But many of us are not familiar with the use and variety of coffee machines. Without coffee machines, we probably would not witness so many people drinking this worldwide popular drink and being able to affordably prepare them at home. For many coffee lovers, there are just a few things more attractive than waking up to a brewed pot of coffee. That first cup begins your whole day the right way. And, if it is brewed the way you want, you will sense that added tang in your effort from morning till night. Nevertheless, if that first cup is excessively hot or not hot enough, too strong or too watery, you quickly find yourself feeling like someone has disordered your very core Most people love to drink coffee, and it is a known truth that coffee can provide a boost of energy and warm your body up on those chilly winter days. But many of us are not familiar with the use and variety of coffee machines. Without coffee machines, we probably would not witness so many people drinking this worldwide popular drink and being able to affordably prepare them at home. For many coffee lovers, there are just a few things more attractive than waking up to a brewed pot of coffee. That first cup begins your whole day the right way. And, if it is brewed the way you want, you will sense that added tang in your effort from morning till night. Nevertheless, if that first cup is excessively hot or not hot enough, too strong or too watery, you quickly find yourself feeling like someone has disordered your very core.',
//     imageUrl: '',
//   },

// ];

const BlogDetail = () => {
  const { store } = useContext(CountryContext);
  const { blogDetail } = useParams();
  const urlKey = blogDetail?.replace('.html','');
  // eslint-disable-next-line
  const { data: filterDataRes, loading: loading } = useQuery(queries.productQueries.BLOG_DETAIL,{
    context: {
      headers: {
         Connection: "keep-alive",
         store: store,
      },
    },
    variables: {
      url_key: urlKey
    }
  }); //, refetch: refetchBlog
  const blogData = filterDataRes?.getSingleBlog;
  const recentPosts = blogData && blogData?.recentPosts; 
  const blogDescription = {__html: blogData?.description};
  return (
    <Box sx={{ width: '100%', padding: 0 }}>
      <Box mb={4}>
        <Card style={{ height: '100%' }}>
          
          {
            (loading) ? (
                <Loader />
            ) : (
              <>
                <CardMedia
                  component="img"
                  height="140"
                  image={blogData?.banner}
                  alt={"Main Banner"}
                />
                <Grid container spacing={2} style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <Grid item xs={12} sm={8}>
                      <Card style={{ height: '100%' }}>
                        <CardContent>
                          <Typography gutterBottom variant="h6" component="div" padding={2}>
                            {blogData?.title}
                          </Typography>
                          <Typography variant="body1" paragraph>
                            <div dangerouslySetInnerHTML={blogDescription} />
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Typography variant="h6" component="h2" sx={{ borderBottom: '2px solid #333', pb: 1, mb: 2, mt: 3 }}>
                      Recent Posts
                    </Typography>
                  <Paper sx={{ p: 3, bgcolor: "#e8eaf4"}}>
                    <List sx={{ listStyleType: 'disc', pl: 4, color: "0f0f0f"}}>
                      {
                        recentPosts?.map((item: any, index: any) => (
                          <>
                            <ListItem sx={{ display: 'list-item' }} key={index}>
                              <Link to={`/${store}/blog/${item.link}`}>{item?.title}</Link>
                            </ListItem>
                          </>
                        ))
                      }
                    </List>
                  </Paper>
                </Grid>
                </Grid>
              </>
            )
          }
        </Card>
      </Box>
    </Box>
  );
};

export default BlogDetail;
